<i18n src="@/locales/models/package.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/exported_batch.yml" lang="yaml"></i18n>

<template>
  <a :class="['link']" @click.prevent="open = true">
    <i :class="['fa-solid', params.icon]"></i>
    <span class="space-icon"></span>
    {{ params.text }}
  </a>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="open = false">
      <div class="
          flex
          items-end
          justify-center
          min-h-screen
          pt-4
          px-4
          pb-20
          text-center
          sm:block sm:p-0
        ">
        <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100"
          leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <TransitionChild as="template" enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
          <div class="panel-modal">
            <div class="panel-modal-close">
              <button type="button" class="panel-modal-close" @click="open = false">
                <span class="sr-only">Close</span>
                <i class="h-6 w-6 fa-solid fa-xmark"></i>
              </button>
            </div>

            <div class="panel-header-title">
              {{ params.data.batch_code }}
            </div>

            <div class="panel-modal-body">
              <div class="table-first-container">
                <div class="table-second-container">
                  <div class="table-third-container">
                    <table class="table">
                      <thead class="table-header">
                        <tr>
                          <th scope="col" class="table-header-cell">
                            {{ $t("model.package.producer") }}
                          </th>
                          <th scope="col" class="table-header-cell">
                            {{ $t("model.exported_batch.crop_field") }}
                          </th>
                          <th scope="col" class="table-header-cell">
                            {{ $t("model.package.exporter_process_brand") }}
                          </th>
                          <th scope="col" class="table-header-cell">
                            {{ $t("model.package.process_line") }}
                          </th>
                          <th scope="col" class="table-header-cell">
                            {{ $t("model.package.quantity") }}
                          </th>
                        </tr>
                      </thead>
                      <tbody class="table-body">
                        <tr class="table-row" v-for="pkg in params.data.packages" :key="pkg.id">
                          <td class="table-cell">
                            {{ pkg.producer.fullname }}
                          </td>
                          <td class="table-cell">
                            {{ pkg.exported_batch?.crop_field?.name }}
                          </td>
                          <td class="table-cell">
                            {{ pkg.exporter_process_brand.agro_exporter_brand.name }}
                          </td>
                          <td class="table-cell">
                            {{ pkg.process_line?.name }}
                          </td>
                          <td class="table-cell">
                            {{ pkg.quantity }}
                            {{
                              $t("model.package.exporter_process_crop_package_value", {
                                name: pkg.exporter_process_crop_package.name,
                                weight: pkg.exporter_process_crop_package.net_weight
                              })
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>

            <div class="panel-modal-footer">
              <button type="button" class="panel-modal-footer-close" @click="open = false">
                Cerrar
              </button>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { ref } from "vue";
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

export default {
  name: "ModalLink",
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
  },
  setup() {
    const open = ref(false);

    return {
      open,
    };
  }
};
</script>
